import { html } from '@resn/gozer-core';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { PAGE_DATA } from 'data/page-data';
import { Router } from '@resn/gozer-core/router';
import { map } from '@resn/gozer-math';

import './index.scss';

import getStore from 'core/store';
import { autobind } from 'core-decorators';
import softwareAppData from 'data/software-app-data';
import { defer } from 'underscore';
import { navigate } from 'utils/router-utils';
const store = getStore();

const links = [PAGE_DATA.OXEFIT, PAGE_DATA.OXELEAD, PAGE_DATA.OXELIFE];

const template = ({ props }) => html`
    <div class="oxeSubHeader">
        <div
            class="oxeSubHeader__inner"
            ?active=${props.active}
            @pointerover=${{
                handleEvent: () => (props.pointerOver = true),
                passive: true,
            }}
            @pointerout=${{
                handleEvent: () => (props.pointerOver = false),
                passive: true,
            }}
        >
            <nav class="oxeSubHeader__nav  text-mainNav" data-ui="nav"></nav>
        </div>
    </div>
`;

@componentMixin(DomComponentMixin)
class OxeSubHeader extends Component {
    options = {
        template,
    };

    props = {
        visible: () => store.state.route.page.includes('oxe') && !store.state.menu.open,
        active: (props) =>
            props.visible &&
            ((store.state.scroll > 10 ? store.state.scrollDir == -1 : true) ||
                props.pointerOver ||
                props.pointerOverLink),
        page: () => store.state.route.page,
        pointerOver: false,

        bannerH: () => store.state.promoBannerHeight,
        y: (props) =>
            store.state.showPromoBanner ? map(store.state.scroll, 0, props.bannerH, props.bannerH, 0, true) : 0,
    };

    setY(val) {
        this.el.style.transform = `translateY(${val}px)`;
    }

    async onSetup() {
        await this.createLinks();
        await this.createBar();

        defer(this.resize);
    }

    async createLinks() {
        this.links = await Promise.all(
            links.map(async (link) => {
                return await new OxeSubHeaderLink().setup({
                    options: {
                        appendTo: this.ui['nav'],
                        label: link.name,
                        navigateTo: this.onNavItemClick,
                        link,
                    },
                    props: {
                        active: () => this.props.page == link.name,
                    },
                });
            }),
        );
    }
    async createBar() {
        this.bar = await new OxeSubHeaderBar().setup({
            options: {
                appendTo: this.ui['nav'],
            },
            props: {
                visible: () => this.props.visible,
            },
        });
    }

    onNavItemClick(item, evt) {
        evt.preventDefault();
        navigate(item.path);
    }

    setPage(page) {
        this.links.forEach((l) => {
            if (l.props.active) {
                this.bar.transformTo({ translate: l.props.x, width: l.props.w });
                this.el.style.setProperty('--highlight-color', softwareAppData[page].color);
            }
        });
    }

    @autobind
    resize() {
        this.links.forEach((l) => {
            const bbox = l.el.getBoundingClientRect();
            l.props.w = bbox.width;
            l.props.x = l.el.offsetLeft + bbox.width * 0.5;

            if (l.props.active) this.bar.transformTo({ translate: l.props.x, width: l.props.w });
        });
    }
}

export default OxeSubHeader;

// Link ---------------------------------------------------------------

@componentMixin(DomComponentMixin)
class OxeSubHeaderLink extends Component {
    options = {
        template: ({ props, options }) => {
            return html`
                <li class="oxeSubHeader__navItem" ?active=${props.active}>
                    <a
                        class="oxeSubHeader__navItemLink"
                        href="${options.link.path}"
                        @click=${(e) => {
                            e.preventDefault();
                            options.navigateTo(options.link, e);
                        }}
                    >
                        <span>${options.label}</span>
                        <span class="ref">${options.label}</span>
                        <span class="on">${options.label}</span>
                    </a>
                </li>
            `;
        },
    };

    props = {};

    async onSetup() {}
}

// Bar ---------------------------------------------------------------

@componentMixin(DomComponentMixin)
class OxeSubHeaderBar extends Component {
    options = {
        template: () => html` <div class="oxeSubHeader__bar bar"></div> `,
    };

    props = {
        v: 0,
        w: 300,
        translate: 0,
    };

    async onSetup() {}
    onVisible() {
        this.props.v = true;
    }
    offVisible() {
        // this.transformTo({ translate: this.props.translate, width: 0, opacity: 0 });
    }

    setV(v) {
        this.el.style.visibility = v ? 'visible' : 'hidden';
    }

    transformTo({ translate, width } = {}) {
        const x = translate - this.props.w * 0.5;
        const sc = width / this.props.w;

        this.el.style.transform = `translateX(${x}px) scaleX(${sc})`;

        this.props.translate = translate;
    }
}
